import { apiConfig } from "../../../config/apiConfig";
import { bookingUsPostCallWrapper } from "../apibookingCallWrapper";
import { storeBookingApiPayload, getBrandDetailsFromBrandJson } from "../../../util/share";
import { gtmCustomEventLeadFlow } from "../../../util/gtm-custom-event-lead-flow";
import { stopLoader } from "../../../util/loader";
import { s3upload } from "../../../util/fileUploads3";
import { REGEX } from "../../../constants/regex";
import { disclaimerHandleCheck } from "../../../util/disclaimerService";
import { DomainIdentifier } from "../../../util/domainService";
import { LocalizationIdentifier } from "../../../util/localizationService";


// Reuse existing button/error handler
function handleButtonClickAndError(
    buttonId: string,
    errorMessageId: string,
    noServiceElementId: string
) {
    const btnClick = document.getElementById(buttonId);
    const errorMessage = document.getElementById(errorMessageId);

    if (btnClick) {
        btnClick.click();
    }

    if (errorMessage) {
        errorMessage.classList.remove('hidden');

        const noServiceError = document.getElementById(noServiceElementId);
        if (noServiceError) {
            noServiceError.classList.add('hidden');
        }
    }
}

export async function handleBookingSubmit(
    requestBody: any,
    gtmEventName: string,
    errorModalId: string,
    errorMessageId: string,
    noServiceElementId: string,
    redirectFn: () => void
) {
    try {
        const response = await bookingUsPostCallWrapper(apiConfig.BOOKING_API_URL, requestBody);

        stopLoader();
        storeBookingApiPayload(requestBody, response);

        // Removed campaign name session storage
        sessionStorage.removeItem('campaignName');

        const submitObj = {
            event: gtmEventName,
            status: 'success'
        };
        gtmCustomEventLeadFlow(submitObj);

        redirectFn();
    } catch (err) {
        stopLoader();

        handleButtonClickAndError(errorModalId, errorMessageId, noServiceElementId);

        const submitObj = {
            event: gtmEventName,
            status: 'failure'
        };
        gtmCustomEventLeadFlow(submitObj);
    }
}

export async function getBrandData(): Promise<any> {
    const conceptCodeElement = document.getElementById('conceptCode') as HTMLInputElement;
    if (!conceptCodeElement) {
        throw new Error('Concept code element not found');
    }
    const conceptCode = conceptCodeElement.value;
    if (!conceptCode) {
        throw new Error('Concept code is empty');
    }
    return await getBrandDetailsFromBrandJson(conceptCode);
}


// Utility function to handle checkbox validation and error toggling.

export function handleCheckboxChangeUtility(formId: string) {
    const forms = document.querySelector(formId);
    if (!forms) {
        console.log('Form doesnt exist.');
        return;
    }
    const serviceReminderDivs = forms?.querySelectorAll('.service-reminder-main');
    let errorID = null;

    if (!serviceReminderDivs || serviceReminderDivs?.length === 0) {
        console.log('Service Disclaimer not authored in CP');
        return;
    }

    serviceReminderDivs.forEach((div: Element) => {
        if (div && !div.classList.contains('hidden')) {
            const checkbox = div.querySelector('input[type="checkbox"]');
            const errorMsg = div.querySelector('.error-msg');

            if (checkbox && errorMsg && checkbox instanceof HTMLInputElement && checkbox?.required) {
                checkbox.addEventListener('change', () => {
                    if (checkbox?.checked) {
                        errorMsg.classList.add('hidden');
                    } else {
                        errorMsg.classList.remove('hidden');
                        errorID = errorMsg?.id;
                    }
                });

                // Initial check on load
                if (checkbox?.required && !checkbox?.checked) {
                    errorMsg.classList.remove('hidden');
                    errorID = errorMsg?.id;
                }
            }
        }
    });

    return errorID;
}

export function showAndFocusErrors(errors: Record<string, string>) {
    // Update all fields with errors
    Object.keys(errors).forEach(fieldId => {
        const field = document.getElementById(fieldId);
        const fieldError = document.getElementById(`${fieldId}-error-msg`);

        // Defensive: ensure element exists in DOM
        if (field?.parentNode) {
            field.classList.add("invalid-field");
            if (fieldError) {
                fieldError.innerHTML = errors[fieldId];
                fieldError.classList.remove("hidden");
            }
        }
    });

    // Focus the first error field AFTER rendering all errors
    const firstErrorFieldId = Object.keys(errors)[0];
    if (firstErrorFieldId) {
        const firstErrorField = document.getElementById(firstErrorFieldId);
        if (firstErrorField) {
            firstErrorField.focus();
        }
    }
}

export function handleHideError(id: any) {
    const field: any = document.getElementById(id);
    const fieldError: any = document.getElementById(`${id}-error-msg`);

    fieldError?.classList.add('hidden')
    field?.classList.remove('invalid-field')
}

export function attachClearFieldListeners(inputIds: string[]) {
    inputIds.forEach((id) => {
        const input = document.getElementById(id) as HTMLInputElement;
        if (input) {
            input.addEventListener("input", () => {
                input.classList.remove("invalid-field");
                const errmsg = document.getElementById(`${id}-error-msg`);
                if (errmsg) errmsg.remove();
            });
        }
    });
}

export function handleFilePreview(fileInput: any, index: number, FilesUrl: any[]): void {
    const file = fileInput?.files && fileInput?.files[0];
    s3upload(file, (fs) => {
        FilesUrl[index] = fs

    })

    const fileName = file.name;
    const fileExt = fileName.split('.')[1]?.trim();
    const imgFiles = ["png", "svg", "jpg", "jpeg"].includes(fileExt);
    const pdfFiles = fileExt === "pdf";
    const excelFiles = fileExt === "xlsx";
    const docFiles = ["docx", "doc"].includes(fileExt);
    if (file) {
        const reader = new FileReader();
        reader.onload = () => {
            const previewContainer: any = document?.querySelectorAll('.file-upload img')[index];
            const uploadData: any = document?.querySelectorAll('.upload-data')[index];
            if (previewContainer) {
                if (imgFiles) {
                    previewContainer.src = reader.result as string;
                    previewContainer.style.display = "block";
                    uploadData.classList.add('active')
                } else if (pdfFiles) {
                    previewContainer.src = "/brand/_assets/images/icons/pdf-icon.svg";
                    previewContainer.style.display = "block";
                    uploadData.classList.add('active')
                } else if (excelFiles) {
                    previewContainer.src = "/brand/_assets/images/icons/excel-icon.svg";
                    previewContainer.style.display = "block";
                    uploadData.classList.add('active')
                } else if (docFiles) {
                    previewContainer.src = "/brand/_assets/images/icons/doc-icon.svg";
                    previewContainer.style.display = "block";
                    uploadData.classList.add('active')
                }

            }
        };
        reader.readAsDataURL(file);
    }
}

export function initCustomSelectHelper(): void {
    const customSelectOption = document.querySelectorAll<HTMLElement>('.custom-select .select-selected');
    const customSelect = document.querySelectorAll<HTMLElement>('.custom-select .select-items');

    if (customSelectOption.length >= 2) {
        (customSelectOption[1] as HTMLButtonElement).disabled = true;
    }

    customSelect.forEach((selectItem, i) => {
        selectItem.addEventListener('click', function (this: HTMLElement) {
            const option = customSelectOption[i];
            if (option) {
                option.style.backgroundColor = "var(--primary-500)";
                option.style.color = "var(--white)";
            }
        });
    });

    if (customSelectOption[0]) {
        customSelect[0].addEventListener('click', function () {
            customSelectOption[0].style.backgroundColor = "var(--primary-500)";
            customSelectOption[0].style.color = "var(--white)";
            (customSelectOption[1] as HTMLElement)?.removeAttribute('disabled');
        });
    }
}

export function zipCodeValidation(inputVal: string): string {
    const zipRegex = REGEX.sendZip;
    if (!inputVal.trim()) {
        return "Zip code is required.";
    }
    if (!zipRegex.test(inputVal.trim()) || inputVal.trim() === "00000") {
        return "Invalid zip code format.";
    }
    return "";
}

export function cityNameValidation(inputVal: string): string {
    const cityRegex = REGEX.sendName;
    if (!inputVal.trim()) {
        return "City is required.";
    }
    if (!cityRegex.test(inputVal)) {
        return "Enter valid city.";
    }
    return "";
}

export function stateNameValidation(inputVal: string): string {
    if (!inputVal || inputVal === "") {
        return "State is required.";
    }
    return "";
}

export function commonInputError(inputElement: any, errorId: any, validationRegex: any, errorMessage: any) {
    const getErrMsg = (document.getElementById(errorId) as HTMLElement)?.getAttribute('aria-describedby');
    const fieldError = document.getElementById(errorId) as HTMLElement;

    if (inputElement.value !== '' && !validationRegex.test(inputElement.value)) {
        if (fieldError) {
            fieldError.classList.remove('hidden');
            fieldError.innerHTML = getErrMsg ?? errorMessage;
        }
    } else {
        inputElement.classList.remove("invalid-field");
        if (fieldError) {
            fieldError.classList.add('hidden');
        }
    }
}

export function handleOptinEmailCheck(
    requestBody: any,
    formSelector: string,
    usCheckboxId: string,
    caCheckboxId: string,
    context: string //being used in contactusmobile and formwhite
): any {
    try {
        const domain = DomainIdentifier();
        const localisation = LocalizationIdentifier();

        const countryZip = !REGEX.sendCaPostalCode.test(requestBody.zipCode) ? 'us' : 'ca';

        let checkboxId = '';
        if (((domain === "us" && !localisation) || (domain === "us" && localisation === "us")) && countryZip === 'us') {
            checkboxId = usCheckboxId;
        } else {
            checkboxId = caCheckboxId;
        }

        const contactForm: any = document.querySelector(formSelector);
        const noteWithRequestBody = disclaimerHandleCheck(false, contactForm, requestBody, requestBody.zipCode, checkboxId);
        return noteWithRequestBody;
    } catch (error) {
        console.error(`An error occurred in disclaimerHandleCheck in ${context}:`, error);
        return requestBody;
    }
}

// selectCommon being used in hms folder hmsstep3 and step3
export function closeAllSelectCommon(elmnt: HTMLElement): void {
    const x = document.getElementsByClassName("select-items slim-scroll");
    const y = document.getElementsByClassName("select-selected");
    const xl = x.length;
    const yl = y.length;
    const arrNo: number[] = [];

    for (let i = 0; i < yl; i++) {
        if (elmnt === y[i]) {
            arrNo.push(i);
        } else {
            y[i].classList.remove("select-arrow-active");
        }
    }

    for (let i = 0; i < xl; i++) {
        if (!arrNo.includes(i)) {
            x[i].classList.add("select-hide");
        }
    }
}

